import { render, staticRenderFns } from "./entrada-detalle.vue?vue&type=template&id=d6712cd8"
import script from "./entrada-detalle.vue?vue&type=script&lang=js"
export * from "./entrada-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports